<template>
  <modal
    name="popup-modal"
    transition="nice-modal-fade"
    :min-width="200"
    :min-height="400"
    :delay="100"
    :adaptive="true"
  >
    <div class="contact-contents">
      <h1>Contact</h1>
      <ul>
        <li>
          <span>Seoul, Kangnam Gu, Cheongdam Dong 100-17, 6F</span>
          <span>
            <a href="tel:02-515-0534">02 515 0534</a>
          </span>
          <span>
            <a href="tel:010-7733-0522">010 7733 0522</a>
          </span>
          <span>
            <a href="mailto:swater01@hanmail.net">swater01@hanmail.net</a>
          </span>
          <span>
            <a href="http://www.instagram.com/leejaeha_architects"
              >instagram @leejaeha_architects</a
            >
          </span>
        </li>
      </ul>
    </div>
  </modal>
</template>
<script>
export default {
  name: "popupmodal",
};
</script>

<style lang="scss" scoped>
a {
  color: #888;
  text-decoration: none;
  &:visited,
  &:focus,
  &:link,
  &:hover {
    text-decoration: none;
    color: #888;
  }
}
</style>